// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vHje","colBig":"styles_colBig__2QqgB","colSmall":"styles_colSmall__J0X2N","shopifyNameWrapper":"styles_shopifyNameWrapper__aggzu"};